import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitForDirective } from './wait-for.directive';



@NgModule({
    declarations: [
        WaitForDirective,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        WaitForDirective,
    ]
})
export class CbWaitForModule { }
